import {Form} from "antd";
import moment from "moment";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
const {RADIO, INPUT, SELECT, COMBO_BOX, DATE} = FIELD_TYPE;
const css = {
  css: {xs: 12, sm: 12, md: 12, lg: 12, xl: 12},
  wrapperCol: {xs: 16, sm: 16, md: 16, lg: 16, xl: 16},
  labelCol: {xs: 8, md: 8, lg: 8},
};
const optionsEyes = [
  {label: "Trái", value: 0},
  {label: "Phải", value: 1},
  {label: "Cả 2 mắt", value: 2},
];
const fields: any[] = [
  {
    key: "0",
    name: "loaiThuoc",
    label: "Loại thuốc",
    type: COMBO_BOX,
    ...css,
    rules: [{required: true, message: "Chưa chọn thuốc"}],
  },

  {
    key: "0",
    name: "viTriMat",
    label: "Vị trí mắt",
    type: SELECT,
    options: optionsEyes,
    ...css,
  },
  {
    key: "0",
    name: "bacSi",
    label: "Bác sĩ chỉ định",
    type: INPUT,
    css: {xs: 12, sm: 12, md: 12, lg: 12, xl: 12},
    wrapperCol: {xs: 16, sm: 16, md: 16, lg: 16, xl: 16},
    labelCol: {xs: 8, md: 8, lg: 8},
  },
  {
    key: "0",
    name: "nguoiTra",
    label: "Người tra",
    type: INPUT,
    css: {xs: 12, sm: 12, md: 12, lg: 12, xl: 12},
    wrapperCol: {xs: 16, sm: 16, md: 16, lg: 16, xl: 16},
    labelCol: {xs: 8, md: 8, lg: 8},
  },

  {
    key: "0",
    name: "ghiChu",
    label: "Ghi chú",
    type: INPUT,
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    wrapperCol: {xs: 20, sm: 20, md: 20, lg: 20, xl: 20},
    labelCol: {xs: 4, md: 4, lg: 4},
  },
];
export {fields};
